import React, { useState, useEffect } from 'react';
import Header from '../Header';
import { Card, Form, Container, Row, Col, Alert } from 'react-bootstrap';

const AddPayment = () => {
  const [users, setUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState('');
  const [services, setServices] = useState([]);
  const [selectedService, setSelectedService] = useState('');
  const [selectedServiceObj, setSelectedServiceObj] = useState(null);
  const [plans, setPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState('');
  const [selectedPlanObj, setSelectedPlanObj] = useState(null);
  const [otherService, setOtherService] = useState('');
  const [paymentMode, setPaymentMode] = useState('');
  const [totalAmount, setTotalAmount] = useState(0);
  const [maxAmount, setMaxAmount] = useState(0);
  const [amountError, setAmountError] = useState('');
  const [remarks, setRemarks] = useState('');
  const [paymentDate, setPaymentDate] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [loading, setLoading] = useState(false);
  const [invoiceNo, setInvoiceNo] = useState('');

  // Fetch users on mount
  useEffect(() => {
    fetch('https://apiaksharaconnect.aksharafinalytics.in/users')
      .then((res) => res.json())
      .then((data) => {
        setUsers(data.user || []);
        
      })
      .catch((err) => console.error('Error fetching users:', err));
  }, []);

  // Fetch services & plans from userdetails API
  useEffect(() => {
    if (selectedUserId) {
      fetch(`https://apiaksharaconnect.aksharafinalytics.in/userdetails/${selectedUserId}`)
        .then((res) => res.json())
        .then((data) => {
          const userDetails = data.userdetails || [];
          console.log(userDetails);
          const groupedServices = Object.values(
            userDetails.reduce((acc, item) => {
              if (!acc[item.service_id]) {
                acc[item.service_id] = {
                  service_id: item.service_id,
                  service_name: item.service_name,
                  total_amount: Number(item.due) || 0,
                  others: item.others,
                  plans: [],
                };
              }

              acc[item.service_id].plans.push({
                plan_id: item.plan_id,
                plan_name: item.plan_name,
                plan_price: Number(item.plan_price),
              });

              return acc;
            }, {})
          );

          setServices(groupedServices);
          setSelectedService('');
          setPlans([]);
          setSelectedPlan('');
          setSelectedPlanObj(null);
          setSelectedServiceObj(null);
          setTotalAmount(0);
          setMaxAmount(0);
          setAmountError('');
        })
        .catch((err) => console.error('Error fetching user details:', err));
    } else {
      setServices([]);
      setPlans([]);
      setSelectedService('');
      setSelectedServiceObj(null);
      setSelectedPlan('');
      setSelectedPlanObj(null);
      setTotalAmount(0);
      setMaxAmount(0);
      setAmountError('');
    }
  }, [selectedUserId]);

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!selectedUserId || !selectedService || !selectedPlanObj || !paymentMode || !paymentDate) {
      setMessage('Please fill in all required fields.');
      setMessageType('danger');
      return;
    }

    if (totalAmount <= 0) {
      setMessage('Total amount must be greater than 0.');
      setMessageType('danger');
      return;
    }

    if (totalAmount > maxAmount) {
      setMessage(`Total amount cannot exceed ₹${maxAmount}.`);
      setMessageType('danger');
      return;
    }

    setLoading(true);

    const formData = {
      invoice_no: invoiceNo,
      user_id: selectedUserId,
      service_id: selectedService,
      plan_id: selectedPlanObj.plan_id,
      other_service: otherService,
      total_amount: totalAmount,
      payment_mode: paymentMode,
      remarks: remarks,
      payment_date: paymentDate
    };

    fetch('https://apiaksharaconnect.aksharafinalytics.in/createtransaction', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message) {
          setMessage('Payment added successfully!');
          setMessageType('success');

          setSelectedUserId('');
          setSelectedService('');
          setSelectedPlan('');
          setSelectedPlanObj(null);
          setOtherService('');
          setTotalAmount(0);
          setPaymentMode('');
          setRemarks('');
          setPaymentDate('');
        } else {
          setMessage(data.message || 'Failed to add payment. Please check all fields again.');
          setMessageType('danger');
        }
      })
      .catch((error) => {
        console.error('Error submitting form:', error);
        setMessage('An error occurred while submitting the form.');
        setMessageType('danger');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Header />
      <Container className="mt-5">
        {message && (
          <Alert variant={messageType} onClose={() => setMessage('')} dismissible>
            {message}
          </Alert>
        )}
        <Card className="shadow">
          <Card.Header>
            <h2>Add Payments</h2>
          </Card.Header>
          <Card.Body>
            <Form onSubmit={handleSubmit}>
              {/* User Dropdown */}
              <Form.Group as={Row} controlId="invoiceNo" className="mb-3">
                <Form.Label column sm={2}>Invoice No</Form.Label>
                <Col sm={10}>
                  <Form.Control
                    type="text"
                    value={invoiceNo}
                    onChange={(e) => setInvoiceNo(e.target.value)}
                    required
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row} controlId="userSelect">
                <Form.Label column sm={2}>User</Form.Label>
                <Col sm={10}>
                  <Form.Select
                    value={selectedUserId}
                    onChange={(e) => setSelectedUserId(e.target.value)}
                    required
                  >
                    <option value="">-- Select User --</option>
                    {users.map((user) => (
                      <option key={user.id} value={user.id}>
                        {user.company}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
              </Form.Group>

              {/* Service Dropdown */}
              {services.length > 0 && (
                <Form.Group as={Row} controlId="serviceSelect" className="mt-3">
                  <Form.Label column sm={2}>Service</Form.Label>
                  <Col sm={10}>
                    <Form.Select
                      value={selectedService}
                      required
                      onChange={(e) => {
                        const selectedServiceId = e.target.value;
                        setSelectedService(selectedServiceId);

                        const matchedService = services.find(
                          (service) => service.service_id === selectedServiceId
                        );

                        if (matchedService) {
                          console.log('matchedService.total_amount:', matchedService.total_amount); 
                          const amount = matchedService.total_amount || 0;
                          setSelectedServiceObj(matchedService);
                          setTotalAmount(amount);
                          setMaxAmount(amount);
                          setPlans(matchedService.plans || []);
                          setSelectedPlan('');
                          setSelectedPlanObj(null);
                          setOtherService(matchedService.others || '');
                          setAmountError('');
                        } else {
                          setSelectedServiceObj(null);
                          setTotalAmount(0);
                          setMaxAmount(0);
                          setOtherService('');
                          setPlans([]);
                          setSelectedPlan('');
                          setSelectedPlanObj(null);
                          setAmountError('');
                        }
                      }}
                    >
                      <option value="">-- Select Service --</option>
                      {services.map((service) => (
                        <option key={service.service_id} value={service.service_id}>
                          {service.service_name}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                </Form.Group>
              )}

              {/* Plan Dropdown */}
              {plans.length > 0 && (
                <Form.Group as={Row} controlId="planSelect" className="mt-3">
                  <Form.Label column sm={2}>Plan</Form.Label>
                  <Col sm={10}>
                    <Form.Select
                      value={selectedPlan}
                      required
                      onChange={(e) => {
                        const planId = e.target.value;
                        const foundPlan = plans.find((plan) => plan.plan_id.toString() === planId);
                        setSelectedPlan(planId);
                        setSelectedPlanObj(foundPlan || null);

                        if (foundPlan?.plan_name?.toLowerCase() === 'others' && selectedServiceObj?.others) {
                          setOtherService(selectedServiceObj.others);
                        }
                      }}
                    >
                      <option value="">-- Select Plan --</option>
                      {plans.map((plan) => (
                        <option key={plan.plan_id} value={plan.plan_id}>
                          {plan.plan_name} 
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                </Form.Group>
              )}

              {/* Other Service Input */}
              {selectedPlanObj?.plan_name === 'Others' && (
                <Form.Group as={Row} controlId="otherService" className="mt-3">
                  <Form.Label column sm={2}>Other Service</Form.Label>
                  <Col sm={10}>
                    <Form.Control
                      type="text"
                      placeholder="Enter Other Service"
                      value={otherService}
                      onChange={(e) => setOtherService(e.target.value)}
                      required
                    />
                  </Col>
                </Form.Group>
              )}

              {/* Total Amount Input */}
              {selectedPlanObj?.plan_name && (
                <Form.Group as={Row} controlId="totalAmount" className="mt-3">
                  <Form.Label column sm={2}>Total Amount</Form.Label>
                  <Col sm={10}>
                  <Form.Control
                        type="text"
                        placeholder="Total Amount"
                        value={totalAmount}
                        onChange={(e) => {
                          let value = Number(e.target.value); // Ensure the value is a number
                  
                          // Check if the value exceeds maxAmount
                          if (value > maxAmount) {
                            setAmountError(`Total amount cannot exceed ₹${maxAmount}.`);
                            value = maxAmount; // Reset to maxAmount if it exceeds
                          } 
                          // Ensure the value is greater than 0
                          else if (value <= 0) {
                            setAmountError('Total amount must be greater than 0.');
                            value = 0; // Reset to 0 if it's less than or equal to 0
                          } 
                          else {
                            setAmountError(''); // Clear error if value is valid
                          }
                  
                          setTotalAmount(value); // Update totalAmount with the validated value
                        }}
                        min="0"
                      />
                  </Col>
                </Form.Group>
              )}

              {/* Display error message */}
              {amountError && (
                <Alert variant="danger" className="mt-2">
                  {amountError}
                </Alert>
              )}

              {/* Payment Mode Input */}
              <Form.Group as={Row} controlId="paymentMode" className="mt-3">
                <Form.Label column sm={2}>Payment Mode</Form.Label>
                <Col sm={10}>
                  <Form.Select
                    value={paymentMode}
                    onChange={(e) => setPaymentMode(e.target.value)}
                    required
                  >
                    <option value="">-- Select Payment Mode --</option>
                    <option value="QR code">QR Code</option>
                    <option value="bank transfer">Bank Transfer</option>
                    <option value="web payment">Web Payment</option>
                    <option value="cash">Cash</option>
                    <option value="cheque">Cheque</option>
                  </Form.Select>
                </Col>
              </Form.Group>

              {/* Remarks Input */}
              <Form.Group as={Row} controlId="remarks" className="mt-3">
                <Form.Label column sm={2}>Remarks</Form.Label>
                <Col sm={10}>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Enter remarks"
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                  />
                </Col>
              </Form.Group>

              {/* Payment Date Input */}
              <Form.Group as={Row} controlId="paymentDate" className="mt-3">
                <Form.Label column sm={2}>Payment Date</Form.Label>
                <Col sm={10}>
                  <Form.Control
                    type="date"
                    value={paymentDate}
                    onChange={(e) => setPaymentDate(e.target.value)}
                    required
                  />
                </Col>
              </Form.Group>

              {/* Submit Button */}
              {totalAmount > 0 && (
                <div className="mt-4">
                  <button type="submit" className="btn btn-primary" disabled={loading}>
                    {loading ? 'Submitting...' : 'Submit Payment'}
                  </button>
                </div>
              )}
            </Form>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default AddPayment;
